import { render } from "./AboutView.vue?vue&type=template&id=eb29a42c"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=eb29a42c&lang=css"

import exportComponent from "C:\\Users\\Admin\\Desktop\\dev\\dma-sc-question-edits\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__